<template>
  <section v-editable="cms" :class="[name, spacing]">
    <grid
      :class="[{ 'grid--container': !fullwidth }, `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__grid-content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 11 },
        ]"
      >
        <a-copy :cms="cms" :class="`${name}__content`" />
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/molecules/m-articles/m-article-text-v2.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-article-text-wide',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    fullwidth() {
      return (this.cms || {}).fullwidth || false
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-article-text-wide {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: transparent;
  padding: 30px 0;

  &__grid {
    align-items: center;
  }
}
</style>
